import type {ReactElement} from 'react';
import React from 'react';
import {BaseListMobileOptions} from '@Panels/poster-editor-item-list-panel/components/base-list-mobile-options';
import type {LIST_STYLE} from '@PosterWhiteboard/items/text-item/text-list';
import {LIST_TYPES} from '@PosterWhiteboard/items/text-item/text-list';
import type {FillObject} from '@PosterWhiteboard/classes/fill.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromFillOfTextStylesOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromFillOfTextStylesOfActiveItem';
import {useGetKeyFromListOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromListOfActiveItem';
import {useGetKeyFromFillOfListOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromFillOfListOfActiveItem';

interface TextListThumbnailOptionsProps {
  panelId: string;
  onClickColorFill(): void;
}

export function TextListThumbnailOptions({...props}: TextListThumbnailOptionsProps): ReactElement | null {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const fillColor = useGetKeyFromFillOfTextStylesOfActiveItem('fillColor');
  const fillType = useGetKeyFromFillOfTextStylesOfActiveItem('fillType');
  const listType = useGetKeyFromListOfActiveItem('type');
  const listStyle = useGetKeyFromListOfActiveItem('style');
  const listWidth = useGetKeyFromListOfActiveItem('width');
  const listFillType = useGetKeyFromFillOfListOfActiveItem('fillType');
  const listFillColor = useGetKeyFromFillOfListOfActiveItem('fillColor');

  if (
    !activeItem ||
    (activeItem && !('list' in activeItem)) ||
    !fillColor ||
    !listFillColor ||
    listFillType === undefined ||
    listType === undefined ||
    listWidth === undefined ||
    listStyle === undefined
  ) {
    return null;
  }

  const updateListObject = (type: LIST_TYPES, styleToApply?: LIST_STYLE): void => {
    let style: LIST_STYLE;
    if (!styleToApply) {
      style = activeItem.list.getDefaultListStyleFromType();
    } else {
      style = styleToApply;
    }

    let newFillObject: Partial<FillObject> = {};

    if (!activeItem.list.hasList()) {
      newFillObject = {
        fillColor: fillColor,
        fillType: fillType,
      };
    }

    void activeItem.updateFromObject({
      list: {
        type,
        style,
        fill: newFillObject,
      },
    });
  };

  return (
    <BaseListMobileOptions
      panelId={props.panelId}
      onClickColorFill={(): void => {
        props.onClickColorFill();
      }}
      hasList={listType !== LIST_TYPES.NONE}
      updateListObject={updateListObject}
      listObject={{
        type: listType,
        style: listStyle,
        width: listWidth,
        fill: {
          fillColor: listFillColor,
          fillType: listFillType,
        },
      }}
    />
  );
}
